export default "__VITE_ASSET___j4awZEY__"